import Button from "../../front-end-global-components/components/Button/Button";
import Modal from "../../front-end-global-components/components/Modal/Modal";

export default function LogoutModal(props) {
  return (
    <Modal
      show={true}
      canIgnore={true}
      onClose={props.onClose}
      width="inherit-parent-width"
      position="position-fixed bottom-0 left-0 right-0"
      maxWidth="max-width-630px"
      background="false"
      boxShadow="false"
      borderRadius="false"
      height="height-fit-to-content"
    >
      <section className="font-color-secondary font-family-gilroy-medium text-align-center padding-larger background-color-white">
        <div className="font-size-medium">Are you sure you want to logout?</div>

        <section className="display-flex padding-top-larger">
          <Button
            boxShadow={false}
            type="submit"
            variant="danger"
            text="Logout"
            className="border-1px-e5e5e5 margin-right-small"
            onClick={props.logout}
            data-cy="confirm-logout-button"
          />
          <Button
            boxShadow={false}
            text="Cancel"
            variant="secondary"
            onClick={props.onClose}
            className="font-color-secondary border-1px-e5e5e5 margin-left-small"
            data-cy="cancel-logout-button"
          />
        </section>
      </section>
    </Modal>
  );
}
